import React from 'react';
import { connect } from 'react-redux';
import { StoriesContainer, AuthorStories, GenreStories } from '../../../design/LastPage/RecommendedStories';
import CustomStoryActions from './CustomStoryActions';
import { storyPath, authorPath, genrePath, isCurrentEpisodeLocked } from '../../helpers';

const RecommendedStories = ({
  currentEpisode, t, story, locked, authorStories, genreStories, genreStoriesTitle, redirectToAuthor, redirectToGenre
}) => (
  <StoriesContainer
    endOfStory={t.end_of_story}
    readOther={t.read_other}
    locked={locked}
    storyActions={() => <CustomStoryActions currentEpisode={currentEpisode} t={t} story={story} />}
  >
    { authorStories.length > 0 &&
      <AuthorStories title={t.by_author} more={t.see_profile} stories={authorStories} onMore={redirectToAuthor} />
    }
    { genreStories.length > 0 &&
      <GenreStories title={genreStoriesTitle} more={t.see_more} stories={genreStories} onMore={redirectToGenre} />
    }
  </StoriesContainer>
);

const mapState = (state, ownProps) => {
  const mappedStories = stories => (
    stories.map(st => ({
      img: st.thumbnail_url,
      title: st.title,
      author: st.author.display_name,
      episodesCount: I18n.t('components.episode_last_page.recommended_stories.episodes', { count: st.episodes_count }),
      viewsCount: st.views_count,
      subscribersCount: st.subscriptions_count,
      rating: st.rating,
      premium: st.pricing_strategy.type !== 'all_free',
      premiumLabel: I18n.t('common.premium'),
      onClick: () => { window.location.href = storyPath(st.slug); }
    }))
  );

  return {
    authorStories: mappedStories(state.recommendedStories.bySameAuthor),
    genreStories: mappedStories(state.recommendedStories.inSameCategory),
    genreStoriesTitle: `${ownProps.t.recommended_in} ${state.story.category && state.story.category.name}`,
    locked: isCurrentEpisodeLocked(state),
    story: state.story,
    redirectToAuthor: (event) => {
      event.preventDefault();
      window.location.href = authorPath(state.story.author.slug);
    },
    redirectToGenre: (event) => {
      event.preventDefault();
      window.location.href = genrePath(state.story.category.slug);
    }
  };
};

export default connect(mapState)(RecommendedStories);
